module.exports = "/images/icon-rejected.png?22293568a9c3bd5ac59894da39573d06";